import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import AcompanhamentoForm from '../Cadastro/components/AcompanhamentoForm';

const AcompanhamentoEditar = ({
  isReadOnly = false,
  id: propId,
  hideHeader = false
}) => {
  const {
    id: paramId
  } = useParams();
  const id = propId || paramId;
  const isEditing = !!id && !isReadOnly;
  const isViewing = isReadOnly;
  return <Container fluid>
      {!hideHeader && <Row>
          <Col md={12}>
            <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Acompanhamentos',
          path: '/pages/acompanhamentos'
        }, {
          name: isViewing ? 'Detalhes do Acompanhamento' : isEditing ? 'Editar Acompanhamento' : 'Novo Acompanhamento'
        }]} />
          </Col>
        </Row>}
      
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <AcompanhamentoForm acompanhamentoId={id} isReadOnly={isReadOnly} hideHeader={true} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>;
};

export default AcompanhamentoEditar;
